import { render, staticRenderFns } from "./BottomControls.vue?vue&type=template&id=1dfbecd4&scoped=true"
import script from "./BottomControls.vue?vue&type=script&lang=js"
export * from "./BottomControls.vue?vue&type=script&lang=js"
import style0 from "./BottomControls.vue?vue&type=style&index=0&id=1dfbecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbecd4",
  null
  
)

export default component.exports